import * as React from "react";
import {
  Box,
  Text,
  IconButton,
  Button,
  HStack,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
} from "@chakra-ui/react";
import { HiDotsVertical } from "react-icons/hi";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { observer } from "mobx-react";
import { GenericObjective } from "../../../types";

type Props = {
  userId?: string;
  boxShadow?: string;
  mt?: string;
  mb?: string;
  data: any;
  onCheck: (id: string) => any;
  onEdit: (data: GenericObjective) => any;
  onShow: (data: GenericObjective) => any;
  isSubscriptionDeactivated?: boolean;
};

export const Objective: React.FC<Props> = observer(
  ({
    boxShadow,
    mt,
    mb,
    data,
    onCheck,
    onEdit,
    onShow,
    isSubscriptionDeactivated = false,
  }) => {
    const { t } = useTranslation();

    const [isOpen, setIsOpen] = React.useState(false);
    const open = () => setIsOpen(!isOpen);
    const close = () => setIsOpen(false);

    const handleCheck = useCallback(
      (id: string) => {
        onCheck(id);
      },
      [onCheck]
    );

    const handleEdit = useCallback(
      (data: GenericObjective) => {
        onEdit(data);
      },
      [onEdit]
    );

    const handleShow = useCallback(
      (data: GenericObjective) => {
        onShow(data);
      },
      [onShow]
    );

    return (
      <Box
        w={"100%"}
        p="4"
        border="1px"
        borderColor="#EBF3F8"
        borderRadius="16px"
        mt={"15px"}
        boxShadow={boxShadow}
      >
        <HStack>
          <Popover
            returnFocusOnClose={true}
            isOpen={isOpen}
            onClose={close}
            placement="left"
            closeOnBlur={true}
          >
            <PopoverTrigger>
              <Box>
                <IconButton
                  aria-label="Search database"
                  variant="ghost"
                  colorScheme="black"
                  fontSize="16px"
                  icon={<HiDotsVertical />}
                  onClick={open}
                />
              </Box>
            </PopoverTrigger>
            <PopoverContent p={0} maxWidth="fit-content">
              <PopoverBody d="flex" flexDirection="column" p={0}>
                <Button
                  isFullWidth={true}
                  borderRadius="0"
                  variant="outline"
                  onClick={() => handleShow(data)}
                >
                  {t("screens.client.genericObjective.show")}
                </Button>

                <Button
                  isFullWidth={true}
                  borderRadius="0"
                  variant="outline"
                  onClick={() => handleEdit(data)}
                  disabled={isSubscriptionDeactivated}
                >
                  {t("screens.client.genericObjective.edit")}
                </Button>
              </PopoverBody>
            </PopoverContent>
          </Popover>

          <Text fontSize="md" alignSelf="left" flex={1}>
            {data.title}
          </Text>

          <Button
            colorScheme="purple"
            variant="ghost"
            onClick={() => handleCheck(data.id)}
            disabled={isSubscriptionDeactivated}
          >
            {t("screens.client.genericObjective.completed")}
          </Button>
        </HStack>
      </Box>
    );
  }
);
